import React from 'react';
import { Map as LeafletMap, TileLayer } from 'react-leaflet';
// import { Map as LeafletMap, TileLayer } from 'react-leaflet';

import './Map.css';
import 'leaflet/dist/leaflet.css';
import { showDataOnMap } from './utils';
function Map({ countries, center, zoom, casesType }) {
  // console.log(center);
  // console.log(zoom);
  return (
    <div className='map'>
      <LeafletMap center={center} zoom={zoom}>
        <TileLayer
          url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        />

        {showDataOnMap(countries, casesType)}
      </LeafletMap>
    </div>
  );
}

export default Map;
